(function() { window.GUID_83775f70_ad0e_4cff_beaf_7d174d26ec1a = { getGuid: function() { return "83775f70-ad0e-4cff-beaf-7d174d26ec1a"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FixedHeadersHelper {
            get NbInstances() {
                return this.headerHelpers.length;
            }
            static ActivateFixedHeaderFeature(parameters) {
                if (!CS.Controls.FixedHeadersHelper.Instance) {
                    CS.Controls.FixedHeadersHelper.Instance = new FixedHeadersHelper();
                    //CS.DOM.$body.offon('ajaxnavigating.FixedHeaderhelper', function () {
                    //    //Cause un probleme lorqu'un overlay est caller
                    //    //Si on trouve rien de problematique, vos mieux ne pas remettre cette ligne
                    //    //CS.Controls.FixedHeadersHelper.Instance = null;
                    //});
                    $(() => {
                        CS.Controls.FixedHeadersHelper.Instance.Start();
                    });
                    //CS.Ajax.AjaxListener.OnAjaxStateChange((state: Ajax.AjaxState) => {
                    //    if (state == Ajax.AjaxState.SmartScriptsExecuted &&
                    //        CS.Controls.FixedHeadersHelper.Instance &&
                    //        CS.Controls.FixedHeadersHelper.Instance.hasChanged) {
                    //        CS.Controls.FixedHeadersHelper.Instance.Start();
                    //    }
                    //});
                }
                CS.Controls.FixedHeadersHelper.Instance.hasChanged = true;
                CS.Controls.FixedHeadersHelper.Instance.onAfterShow = parameters.OnAfterShow;
                let helper = new Controls.FixedHeaderHelper(parameters);
                helper.OnAfterShowFixedHeader = parameters.OnAfterShow;
                this.RemoveHelperFromListIfIdExist(helper);
                CS.Controls.FixedHeadersHelper.Instance.headerHelpers.push(helper);
                CS.Controls.FixedHeadersHelper.Instance.Start();
                return helper;
            }
            static RemoveHelperFromListIfIdExist(newHelper) {
                if (CS.Controls.FixedHeadersHelper.Instance) {
                    for (var i = 0; i < CS.Controls.FixedHeadersHelper.Instance.headerHelpers.length; i++) {
                        let fixedHeader = CS.Controls.FixedHeadersHelper.Instance.headerHelpers[i];
                        let id = fixedHeader.Id;
                        if (id == newHelper.Id) {
                            fixedHeader.Dispose();
                            CS.Controls.FixedHeadersHelper.Instance.headerHelpers.splice(i, 1);
                        }
                    }
                }
            }
            Start() {
                let me = this;
                me.hasChanged = false;
                me.RefreshAllIFixedHeaders();
                CS.DOM.$win.offon('scroll.fixedheadershelper', function () {
                    me.refreshFixedHeadersVisibilities();
                });
            }
            constructor() {
                let me = this;
                me.headerHelpers = new Array();
            }
            RefreshAllIFixedHeaders() {
                let me = this;
                CS.Lag('refreshallifixedheaders', 0, function () {
                    requestAnimationFrame(function () {
                        for (var i = 0; i < me.headerHelpers.length; i++) {
                            let helper = me.headerHelpers[i];
                            helper.PreCalculateLayoutForFixedHeaderPositionning();
                        }
                        me.refreshFixedHeadersVisibilities();
                    });
                });
            }
            refreshFixedHeadersVisibilities() {
                let me = this;
                let topBarHeight = null;
                requestAnimationFrame(function () {
                    if (!topBarHeight) {
                        let $sectionTop = $('.section-top');
                        if ($sectionTop.length > 0) {
                            topBarHeight = $('.section-top').last()[0].getBoundingClientRect().height;
                        }
                        let $innerSubTop = $('.section-inner-subtop-content');
                        if ($innerSubTop.length > 0) {
                            topBarHeight += $innerSubTop.last()[0].getBoundingClientRect().height;
                        }
                    }
                    let vertWinScroll = CS.DOM.$win.scrollTop();
                    var top = vertWinScroll + topBarHeight;
                    if (CS.DOM.$sectionBottom && CS.DOM.$sectionBottom.length > 0) {
                        //var bottom = CS.DOM.$sectionBottom.offset().top;
                        //sectionBottom offset top etait parfois a zero, cest pourquoi jai adopté une autre facon de trouver le bottom
                        let bottom = vertWinScroll + CS.DOM.$win.outerHeight() - CS.DOM.$sectionBottom.outerHeight();
                        let currentHeaderTop = topBarHeight;
                        for (var i = 0; i < me.headerHelpers.length; i++) {
                            let helper = me.headerHelpers[i];
                            let stickyParentHeight = me.getHeightOfStickyParents(helper.$headerRef);
                            let offset = helper.AnalyseCurrentState(top, bottom, currentHeaderTop + stickyParentHeight);
                            currentHeaderTop += offset;
                            top += offset;
                        }
                    }
                });
            }
            getHeightOfStickyParents($header) {
                let me = this;
                let $stickyParent = $header.parents('.accordion-container');
                let sectionTopHeight = 0;
                sectionTopHeight = 0;
                if ($stickyParent.length > 0) {
                    $.each($stickyParent, (e, element) => {
                        let $this = $(element);
                        let $childs = $this.find('.sticky');
                        $.each($childs, (s, sele) => {
                            sectionTopHeight += sele.getBoundingClientRect().height;
                        });
                    });
                }
                return sectionTopHeight;
            }
        }
        Controls.FixedHeadersHelper = FixedHeadersHelper;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=fixed-headers-helper.pre.js.map
